module.exports = __webpack_public_path__ + "img/portal.a36a788e.svg";